import { createApp } from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import Antd from 'ant-design-vue';
import './styles/index.css';
import './styles/antd.less';

createApp(App).use(router).use(store).use(Antd).mount('#app');
